export type GymTimeZone = 'Australia/Sydney' | 'Africa/Johannesburg' | 'Europe/London';

export const timeZoneISO2CountryMap: { [key in GymTimeZone]: string } = {
  'Australia/Sydney': 'au',
  'Africa/Johannesburg': 'za',
  'Europe/London': 'gb',
};
